// This file was automatically generated and should not be edited.;
import type { SVGProps } from 'react';
import { Ref, forwardRef } from 'react';
const SvgLightBulb = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M9 18h6m-5 3h4m-5-6c0-2-.5-2.5-1.5-3.5S6.023 9.487 6 8c-.048-3.05 2-5 6-5s6.048 1.95 6 5c-.023 1.487-.5 2.5-1.5 3.5S15 13 15 15"
    />
  </svg>
);
export const LightBulbIcon = forwardRef(SvgLightBulb);
